import React from 'react';
import { Link } from 'react-router-dom';
import { FiMapPin, FiMail } from 'react-icons/fi';
import './Footer.css';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-widget">
            <h3>Smartsworks Tech Solutions Private Limited</h3>
            <p><strong>CIN:</strong> U62099DL2019PTC347081</p>
          </div>
          <div className="footer-widget">
            <div className="footer-contact-item">
              <FiMapPin size={18} className="footer-icon" />
              <div>
                <span className="contact-heading">Corporate Office</span>
                <p>
                  DLF Commercial Building, Block 3, Zone 6, DLF Phase 5, DLF QE,
                  Gurugram, Haryana - 122002
                </p>
              </div>
            </div>
          </div>
          <div className="footer-widget">
            <div className="footer-contact-item">
              <FiMapPin size={18} className="footer-icon" />
              <div>
                <span className="contact-heading">Registered Office</span>
                <p>
                  Unit No. 305-310, Plot No. 9, 10 & 11, Vardhman Trade Centre,
                  Nehru Place, South Delhi, Delhi, India, 110019
                </p>
              </div>
            </div>
          </div>
          <div className="footer-widget">
            <div className="footer-contact-item">
              <FiMail size={18} className="footer-icon" />
              <div>
                <span className="contact-heading">Connect</span>
                <a href="tel:011-4881351">011-4881351</a>
                <br />
                <a href="mailto:Info@workctrl.tech">Info@workctrl.tech</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-inner">
            <p>&copy; 2026 by Workctrl. All Rights Reserved</p>
            <nav className="footer-nav">
              <Link to="/">Home</Link>
              <Link to="/product-ecosystem">Product</Link>
              <Link to="/stakeholder">Stakeholder</Link>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
